import React from 'react';
import TeamMember from './TeamMember';
import sanketBhoyar from '../../../assets/images/leadershipteam/SanketBhoyar.jpg';
import mithunBhore from '../../../assets/images/leadershipteam/MithunBhore.jpeg';
import snehalPatil from '../../../assets/images/leadershipteam/SnehalPatil.jpeg';

const teamMembers = [
    //  {
    //      name: 'Sanket Bhoyar',
    //      position: 'Project Head',
    //      imageUrl: sanketBhoyar,
    //      linkedinUrl: 'https://linkedin.com',
    //      behanceUrl: 'https://behance.net',
    //    dribbbleUrl: 'https://dribbble.com'
    //  },
    {
        name: 'Mithun Bhore',
        position: 'Business Head',
        imageUrl: mithunBhore,
        linkedinUrl: 'https://in.linkedin.com/in/mithun-bhore-633779109',
        behanceUrl: 'https://behance.net',
        dribbbleUrl: 'https://dribbble.com'
    },
    {
        name: 'Snehal Patil',
        position: 'HR Admin',
        imageUrl: snehalPatil,
        linkedinUrl: 'https://www.linkedin.com/in/snehal-patil-44b62924b/',
        behanceUrl: 'https://behance.net',
        dribbbleUrl: 'https://dribbble.com'
    }
];

const LeaderShipTeam = () => {
    return (
        <section className="team-section">
        <div className="container">
             <h4>Executive <span>Leadership Team</span></h4>
      <p style={{textAlign:"justify"}}>
        Our team is made up of the best and brightest minds in the industry.
      </p>
            <div className="row">
                {teamMembers.map((member, index) => (
                    <div key={index} className="col-md-4">
                        <TeamMember {...member} />
                    </div>
                ))}
            </div>
        </div>
        </section>
    );
};

export default LeaderShipTeam;
